const phases = [
  {
    number: "01",
    title: "Discovery & Audit",
    timeframe: "Weeks 1–2",
    description:
      "Deep dive into your product, data, channels, and team. I audit your growth stack, identify quick wins, and build a prioritized roadmap.",
  },
  {
    number: "02",
    title: "Build & Execute",
    timeframe: "Months 1–3",
    description:
      "Hands-on execution against the roadmap. I'm in your Slack, your dashboards, your standups. Launching campaigns, building systems, shipping experiments.",
  },
  {
    number: "03",
    title: "Scale & Optimize",
    timeframe: "Ongoing",
    description:
      "Scale what's working, prune what isn't, and build the internal capability for your team to sustain growth independently.",
  },
];

const HowIWorkSection = () => {
  return (
    <section id="how-i-work" className="section-padding bg-background">
      <div className="content-max">
        <h2 className="font-headline text-3xl sm:text-4xl md:text-5xl text-foreground tracking-tight mb-12 md:mb-16">
          How Engagements Work
        </h2>

        {/* Timeline dots + line — desktop only. Dots align with phase numbers (~28px from column left) */}
        <div className="hidden md:grid grid-cols-3 md:gap-8 mb-10 relative">
          <div
            className="absolute top-1/2 h-px bg-border -translate-y-1/2"
            style={{ left: "28px", right: "calc((100% - 4rem) / 3 - 28px)" }}
          />
          {phases.map((phase) => (
            <div key={phase.number} className="relative z-10 flex items-center" style={{ paddingLeft: "22px" }}>
              <div className="w-3 h-3 rounded-full bg-primary" />
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {phases.map((phase) => (
            <div key={phase.number}>
              <span className="font-headline text-6xl md:text-7xl text-primary/20 leading-none select-none block mb-6">
                {phase.number}
              </span>
              <h3 className="font-body text-lg font-semibold text-foreground mb-1.5">
                {phase.title}
              </h3>
              <p className="font-mono text-xs text-primary mb-4">
                {phase.timeframe}
              </p>
              <p className="font-body text-sm text-muted-foreground leading-relaxed">
                {phase.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowIWorkSection;
